import React from "react";

// const InputField = ({
//   label,
//   id,
//   type,
//   placeholder,
//   register,
//   validationRules,
//   errorMessage,

// }) => {
//   return (
//     <div className= "col-md-6" >
//       <label htmlFor={id} className="form-label text-success small">
//         {label}
//       </label>
//       <input
//         type={type}
//         className={`form-control form-control-sm ${
//           errorMessage ? "is-invalid" : ""
//         }`}
//         id={id}
//         placeholder={placeholder}
//         {...register(id, validationRules)}
//       />
//       {errorMessage && <div className="invalid-feedback">{errorMessage}</div>}
//     </div>
//   );
// };
//****************************************************************************
// export default InputField;
// const InputField = ({
//   label,
//   id,
//   type,
//   placeholder,
//   register,
//   validationRules,
//   errorMessage,
// }) => {
//   return (
//     <div className="col-md-6 mb-4">
//       <label
//         htmlFor={id}
//         className="form-label"
//         style={{
//           color: "#4CAF50",
//           fontWeight: "bold",
//           fontFamily: "'Poppins', sans-serif",
//           fontSize: "14px",
//         }}
//       >
//         {label}
//       </label>
//       <input
//         type={type}
//         className={`form-control ${errorMessage ? "is-invalid" : ""}`}
//         id={id}
//         placeholder={placeholder}
//         style={{
//           borderRadius: "6px",
//           borderColor: "#A5C586",
//           backgroundColor: "#F5F0E1",
//         }}
//         {...register(id, validationRules)}
//       />
//       {errorMessage && (
//         <div className="invalid-feedback" style={{ color: "#d9534f" }}>
//           {errorMessage}
//         </div>
//       )}
//     </div>
//   );
// };
//************************************************************************************************* */
// export default InputField;
const InputField = ({
  label,
  id,
  type,
  placeholder,
  register,
  validationRules,
  errorMessage,
}) => {
  return (
    <div className="col-md-6 mb-3">
      <label
        htmlFor={id}
        className="form-label"
        style={{
          color: "#4CAF50",
          fontWeight: "bold",
          fontFamily: "'Poppins', sans-serif",
          fontSize: "14px",
        }}
      >
        {label}
      </label>
      <input
        type={type}
        className={`form-control ${errorMessage ? "is-invalid" : ""}`}
        id={id}
        placeholder={placeholder}
        style={{
          borderRadius: "8px",
          borderColor: "#CBD5E1", // Light grayish-blue for a soft border
          backgroundColor: "#FFFFFF", // Whitish tone for input background
          color: "#4B4B4B",
          // Subtle shadow for depth
          padding: "7px",
        }}
        {...register(id, validationRules)}
      />
      {errorMessage && (
        <div className="invalid-feedback" style={{ color: "#d9534f" }}>
          {errorMessage}
        </div>
      )}
    </div>
  );
};

export default InputField;
